import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import "swiper/css"; 
import "swiper/css/navigation";
import portfolioOneData from "./portfolioOneData";
import { Link } from "react-router-dom";
import { SRLWrapper } from 'simple-react-lightbox';

 
const PortfolioOne = () => {
    return (
        <section className="portfolio-carousel-wrapper clearfix ">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-8 col-xl-7 col-12">
                        <div className="block-contents">
                            <div className="section-title">
                                {/* <span>Best Portfolio</span> */}
                                <h2>MAJOR COMPLETED
                                PROJECTS</h2>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-3 offset-lg-1 col-xl-3 offset-xl-2 text-lg-end col-12">
                        <Link to="/contact" className="theme-btn">Contact Us</Link>
                    </div>
                </div>
            </div>
            <div className="portfolio-carousel-active">
                <Swiper 
                    slidesPerView={3} 
                    spaceBetween={20} 
                    loop
                    modules={[Autoplay]}
                    autoplay={{
                        delay: 3000,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: true,
                    }}
                    breakpoints={{
                        "@0.00": {
                          slidesPerView: 2,
                          spaceBetween: 20,
                          centeredSlides: true,
                          
                        },
                        "@0.75": {
                          slidesPerView: 2,
                          spaceBetween: 20,
                          centeredSlides: true,
                          
                        },
                        "@1.00": {
                          slidesPerView: 3,
                          spaceBetween: 20,
                          
                        },
                        "@1.50": {
                          slidesPerView: 3,
                          spaceBetween: 20,
                        },
                      }}
                >
                {
                    portfolioOneData.map((data) => (
                        <SwiperSlide className="portfolio-slide" key={data.id}>
                            <div className="single-project-item single-project-item--uniform">
                                <SRLWrapper>
                                   <a href={data.img}>
                                   
                                   <div className="project-img bg-cover bg-center popup-gallery" style={{backgroundImage: `url(${data.img})`}}>
                                    {/* <div className="icon">
                                        <p className="project-scope">{data.scope}</p>
                                    </div> */}
                                    </div>
                                   </a>
                                    <div className="content-text">
                                        {data.name && (<h4 className="major-project-name" >{data.name}</h4>)}
                                        {data.client && <span  className="major-project-client">Client: {data.client}<br/></span>} 
                                        
                                        {data.main_contractor && <span className="contractor-one"> Main Contractor: {data.main_contractor}</span>}
                                         {data.contract_value && <p className="contract-value">Contract Value: AED {data.contract_value}</p>} 
                                         {data.scope && <p className="scope-value">Scope :&nbsp;{data.scope}</p>}
                                    </div>
                                </SRLWrapper>
                            </div>
                        </SwiperSlide>
                    ))
                }
                </Swiper>
            </div>
        </section>
    )
}

export default PortfolioOne;